export enum AnnualIncomeErrorCodes {
	AnnualIncomeUpdateRequired = 400263,
}
